import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import RoutingEnum from 'constants/RoutingEnum';

import { RouteAction } from 'actions';

import OrderSettingsStore from 'stores/OrderSettingsStore';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import Menu from 'PMT/entities/menu/Menu';
import CategoryItem from 'PMT/entities/menu/CategoryItem';

// -- views
import AbstractRestaurantMenuComponent from '../components/AbstractRestaurantMenuComponent';
import MenuRow from './components/MenuRow';
import RoundButton from 'components/RoundButton';

export default class MenusListPage extends AbstractRestaurantMenuComponent {

  static propTypes = {
    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,
  };

  static defaultProps = {
    hideDeactivatedMenus: true
  };

  onAddMenuClicked = () => {
    RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU_MENU_NEW);
  };

  onDeleteCategory = () => {
    this.props.onDeleteCategory(this.props.category);
  };

  onMenuEditClicked = (menu: Menu) => {
    this.props.onMenuEditClicked(menu);
  };

  onMenuEditClicked = (menu: Menu) => {
    this.props.onMenuEditClicked(menu);
  };

  //
  // renderers
  //

  renderCreateMenuBtn() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    if (OrderSettingsStore.getOrderSettings().menuManagedByPos) {
      return (null);
    }

    return (
      <RoundButton
        onClick={this.onAddMenuClicked}
        text={I18n.tr('menu.menu_list.create_menu')}
      />
    );
  }

  renderTheadContent() {
    return (
      <tr>
        <th className="hidden-sm col-md-1 text-left">

        </th>
        <th className="col-md-6">
          {I18n.tr('menu.menu_list.name')}
        </th>
        <th className="col-md-1 text-right">
        </th>
        <th className="col-md-1 text-center">
        </th>
      </tr>
    );
  }

  renderList() {
    const menusListView = [];

    _.each(this.restaurantMenu.menus, (menu: Menu) => {
      menusListView.push(
        <MenuRow
          menu={menu}
          key={menu.id}
        />
      );
    });

    return (
      <div className="top-buffer-30 table_container">
        <table className="table table-responsive">
          <thead>
          {this.renderTheadContent()}
          </thead>
          <tbody>
          {menusListView}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div className="menus_list_page top-buffer-30">
        {this.renderCreateMenuBtn()}
        {this.renderList()}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/menus/MenusListPage.js